import axios from './index'

class shop {
    //渠道商列表
    static getDistributorList(params) {
        return axios.get('/app-admin/v1/manager/distributor',{params:params})
    }

    //新增渠道商
    static addDistributor(params) {
        return axios.post('/app-admin/v1/manager/distributor',params)
    }

    //获取渠道商详情
    static getDistributor(params) {
        return axios.get(`/app-admin/v1/manager/distributor/${params}`)
    }

    //编辑渠道
    static editDistributor(params) {
        return axios.put(`/app-admin/v1/manager/distributor/${params.lid}`,params)
    }
 
    //渠道开关
    static switchDistributor(params) {
        return axios.put(`/app-admin/v1/manager/distributor/${params.lid}/state/${params.type}`)
    }


    //供应商列表
    static getSupplierList(params) {
        return axios.get('/app-admin/v1/manager/supplier',{params:params})
    }

    //获取所有供应商信息
    static getSupplierAll(params) {
        return axios.get('/app-admin/v1/manager/supplier/supplierAll',{params:params})
    }


    //供应开关
    static switchSupplier(params) {
        return axios.put(`/app-admin/v1/manager/supplier/${params.lid}/state/${params.type}`)
    }

    //新增供应商
    static addSupplier(params) {
        return axios.post('/app-admin/v1/manager/supplier',params)
    }

    //获取供应详情
    static getSupplier(params) {
        return axios.get(`/app-admin/v1/manager/supplier/${params}`)
    }


    //编辑供应
    static editSupplier(params) {
        return axios.put(`/app-admin/v1/manager/supplier/${params.lid}`,params)
    }


    //渠道账户列表
    static geDistributorAccountList(params) {
        return axios.get('/app-admin/distributor-account/list',{params:params})
    }

    //添加渠道账户
    static addDistributorAccount(params) {
        return axios.post('/app-admin/distributor-account/create',params)
    }

    //修改渠道账户
    static updateDistributorAccount(params) {
        return axios.post('/app-admin/distributor-account/update',params)
    }

    //账户开关
    static updateDistributorState(params) {
        return axios.post(`/app-admin/distributor-account/${params.lid}/state/${params.type}`)
    }

    //渠道账户app
    static apiInfoApp(params) {
        return axios.post('/app-admin/apps/getAppInfo',params)
    }



    
    

    
}

export default shop;
